import { Dropdown, type DropdownProps } from '@packages/shared-ui/v4/form';
import type { Lse } from '@/clients/pxe-backend/lses';

export type LseDropdownProps = Omit<
  DropdownProps,
  'options' | 'value' | 'onChange'
> & {
  lses: Lse[];
  value: number | null;
  onChange: (lseId: number | null) => void;
};

export function LseDropdown({
  lses,
  value,
  onChange,
  ...rest
}: LseDropdownProps) {
  const handleChange = (name: string) => {
    onChange(lses.find((lse) => lse.name === name)?.lseId ?? null);
  };

  return (
    <Dropdown
      {...rest}
      options={lses.map((lse) => lse.name)}
      value={lses.find((lse) => lse.lseId === value)?.name ?? ''}
      onChange={handleChange}
    />
  );
}
